import User_Entity from "./user";
export default class User extends User_Entity {
  static fromList(usersJSON: unknown): Array<User> {
    const users: User[] = [];
    if (usersJSON)
      Array.isArray(usersJSON) &&
        usersJSON.forEach((userJSON) => {
          users.push(new User(userJSON));
        });
    return users;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  fullName(): string {
    return `${this.firstName ?? ""} ${this.lastName ?? ""}`;
  }
}
